export const updateSearchParams = (searchParams, object) => {
    const params = new URLSearchParams(searchParams);

    if (! (typeof object === 'object' && !Array.isArray(object) && object !== null )) {
        return Array.from(params.entries());
    }

    Object.entries(object).forEach(([key, value]) => {

        if (value === null || (Array.isArray(value) && value.length === 0)) {
            params.delete(key);
        } else if (Array.isArray(value)) {
            params.delete(key);
            value.forEach(v => params.append(key, v));
        } else {
            params.set(key, value);
        }
    });

    return Array.from(params.entries());
};